module.exports = __webpack_public_path__ + "static/media/Furgon.59cfcfcf.jpg";